// extracted by mini-css-extract-plugin
export var container = "ProductFilter-module--container--bcc30";
export var heading = "ProductFilter-module--heading--c53ec";